import { useEffect } from 'react';

/**
 * Lock `body` scroll while a modal is open.
 *
 * Stacks across nested modals via a ref-counted lock — opening
 * a child modal while a parent is open keeps the lock active until the
 * last modal closes.
 *
 *   useBodyScrollLock();        // locks on mount, unlocks on unmount
 *   useBodyScrollLock(isOpen);  // toggles with a flag (must be stable across re-renders)
 *
 * Restores the original `body.style.overflow` exactly — so any app-level
 * styling is preserved.
 */
let lockCount = 0;
let prevOverflow = null;

export function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;

    if (lockCount === 0) {
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        document.body.style.overflow = prevOverflow || '';
        prevOverflow = null;
      }
    };
  }, [active]);
}
